import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "~/config/query.config";
import { isAutomatedBrowser } from "~/lib/automation";

interface QueryProviderProps {
  children: React.ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Local development only, and never under automation: the badge pins itself to the
          bottom-right corner, where the bug reporter's button sits, and intercepts its clicks
          (the same reason Agentation is hidden in root.tsx). See lib/automation. */}
      {import.meta.env.DEV && !isAutomatedBrowser() && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}
